import { createSelector } from '@reduxjs/toolkit';

import { getPromoInfos } from './getPromoInfos';
import { IPromoInfo } from '../../types/newbuildingPromos';

export const selectMainPromo = createSelector([getPromoInfos], (promos: IPromoInfo[]): IPromoInfo | null => {
  if (!promos.length) {
    return null;
  }

  return promos.find(promo => promo.isMainPromo) || null;
});
